import { CardElement, PaymentElement, useElements, useStripe } from "@stripe/react-stripe-js";
import { FC, FormEvent } from "react";

export const CardRegistrationForm: FC = () => {

  const stripe = useStripe();
  const elements = useElements();

  async function handleSubmit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    if (!stripe || !elements) {
      return;
    }

    // const result = await stripe.confirmPayment({
    const result = await stripe.confirmSetup({
      elements,
      confirmParams: {
        return_url: `${window.location.origin}/thxarigatoo_creca`,
      },
    });

    if (result.error) {
      // Show error to your customer (for example, payment details incomplete)
      console.log(result.error.message);
    } else {
      // Your customer will be redirected to your `return_url`. For some payment
      // methods like iDEAL, your customer will be redirected to an intermediate
      // site first to authorize the payment, then redirected to the `return_url`.
    }
  };

  return <>
      <form onSubmit={handleSubmit}>
        <div className="mt-4 h-[400px] w-[400px]">
        <CardElement  />
        </div>
        <div className="mt-4"></div>
        
        <button type="submit" className="w-full border py-2" disabled={!stripe || !elements}>
          カードを登録する
        </button>
      </form>
  </>
}